import React, { useContext } from 'react';

import { FetchingPromoContext, initialValue, useFetchingPromoInternal } from './UseFetchingPromoInternal';

const FetchingPromo = React.createContext<FetchingPromoContext>(initialValue);
FetchingPromo.displayName = 'FetchingPromoContext';

export const useFetchingPromoContext = () => useContext(FetchingPromo);

export const FetchingPromoProvider: React.FC = ({ children }) => {
  const fetchingPromo = useFetchingPromoInternal();

  return (
    <FetchingPromo.Provider value={fetchingPromo}>
      {children}
    </FetchingPromo.Provider>
  );
};
